module.exports = __webpack_public_path__ + "img/logo_patronat_marszalka.632ca7e8.jpg";